import { BUSINESS_ADMIN_HOST } from 'api/constants';

export const CHANGE_PASSWORD_URL = `${BUSINESS_ADMIN_HOST}/v1/internal-users/change-password`;
